import axios from "axios";

const configuredBackendUrl = process.env.REACT_APP_BACKEND_URL;
export const BACKEND_URL = configuredBackendUrl || (
    window.location.port === "3203"
        ? `${window.location.protocol}//${window.location.hostname}:9030`
        : window.location.origin
);
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("wd-admin-token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            try { localStorage.removeItem("wd-admin-token"); } catch {}
        }
        return Promise.reject(err);
    }
);

export function adminUrlFor(slug, weddingSlug = "awady") {
    return `${window.location.origin}/w/${weddingSlug}/i/${slug}`;
}

export function absoluteInviteUrl(url, slug, weddingSlug) {
    if (typeof url === "string" && /^https?:\/\//i.test(url)) return url;
    if (typeof url === "string" && url.startsWith("/")) {
        return `${window.location.origin}${url}`;
    }
    return adminUrlFor(slug, weddingSlug);
}

const WHATSAPP_INVITE_MESSAGE = "يسعدنا دعوتكم لحضور حفل الزفاف";

export function whatsappShareUrl(inviteUrl) {
    return `https://wa.me/?text=${encodeURIComponent(`${WHATSAPP_INVITE_MESSAGE}\n${inviteUrl}`)}`;
}

export function pathAfterAdminLogin(role, weddingSlugs) {
    const slugs = Array.isArray(weddingSlugs)
        ? weddingSlugs.filter((slug) => typeof slug === "string" && slug)
        : [];
    if (role === "wedding_admin" && slugs.length === 1) {
        return `/w/${slugs[0]}/admin`;
    }
    return "/admin";
}
